import * as utils from "./utils";

export function commodityToSelect(commodities) {
    let cleanedCommodities = [];
    commodities.map((item) => (
        cleanedCommodities.push({
            label: item.name,
            value: item.id,
            item: item,
        })
    ));
    return cleanedCommodities;
}

export function commodityToForm(commodity) {
    let cleanedCommodity = Object.assign({}, commodity);

    if (cleanedCommodity.commodityGroup !== undefined && cleanedCommodity.commodityGroup.id !== undefined) {
        cleanedCommodity.commodityGroup = cleanedCommodity.commodityGroup.id;
    }

    return cleanedCommodity;
}

export function flattenCommodityGroup(items) {
    let newItems = [];
    for (let i = 0; i < items.length; i++) {
        let newItem = items[i];
        if (utils.notNullNorUndefined(newItem.commodityGroup)) {
            newItems.push({...newItem, commodityGroupName: newItem.commodityGroup.name});
        } else {
            newItems.push(newItem);
        }
    }
    return newItems;
}


// WEBPACK FOOTER //
// ./src/utils/commodity.js